import React from 'react';
import PropTypes from 'prop-types';
const formatTimestamp = timestamp => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
};
const getMessageClassName = ({
  isUser,
  isSystem,
  isWaiting
}) => {
  if (isUser) {
    return 'border border-success bg-light text-dark';
  }
  if (isSystem) {
    return 'bg-light text-dark border border-danger';
  }
  if (isWaiting) {
    return 'bg-light text-dark';
  }
  return 'bg-secondary text-white';
};
const AiChatMessage = ({
  message
}) => {
  const isUser = message.type === 'user';
  const isSystem = message.type === 'system';
  const {
    isWaiting
  } = message;
  return /*#__PURE__*/React.createElement("div", {
    className: `d-flex mb-3 ${isUser ? 'justify-content-end' : 'justify-content-start'}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `chat-message p-3 rounded ${getMessageClassName({
      isUser,
      isSystem,
      isWaiting
    })}`,
    style: {
      maxWidth: '80%'
    }
  }, isWaiting && /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "typing-indicator me-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dot"
  }), /*#__PURE__*/React.createElement("span", {
    className: "dot"
  }), /*#__PURE__*/React.createElement("span", {
    className: "dot"
  })), /*#__PURE__*/React.createElement("span", null, "\xA0", message.content)), !isWaiting && /*#__PURE__*/React.createElement("div", {
    className: "message-content"
  }, message.content), message.timestamp && /*#__PURE__*/React.createElement("div", {
    className: `message-timestamp small mt-1 ${isUser ? 'text-muted' : 'text-muted'}`
  }, formatTimestamp(message.timestamp))));
};
AiChatMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string,
    content: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['user', 'assistant', 'system']).isRequired,
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    conversationId: PropTypes.string,
    isWaiting: PropTypes.bool
  }).isRequired
};
export default AiChatMessage;